var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 5 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99559 5.00013L0.247545 7.7481C-0.0825335 8.0782 -0.0825334 8.6134 0.247545 8.94342C0.577623 9.27342 1.11278 9.27342 1.44286 8.94342L4.75316 5.63292C4.92723 5.45898 5.00877 5.22796 4.99925 5.00013C5.00877 4.7722 4.92723 4.54126 4.75316 4.36726L1.44286 1.05674C1.27757 0.891735 1.06151 0.809185 0.845444 0.809185C0.628648 0.809185 0.412583 0.891735 0.247544 1.05674C-0.082534 1.38685 -0.082534 1.92205 0.247544 2.25207L2.99559 5.00013Z",
    fill: "#112299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionClose);
export default __webpack_public_path__ + "static/media/sectionClose.5dff70250cec2482d6ca0d533c067cb6.svg";
export { ForwardRef as ReactComponent };